import $ from 'jquery';

export const toggleChecked = ($input) => {
    if (!$input.length) return;
    $input.each(function () {
        var $el = $(this),
            isChecked = $el.prop('checked'),
            $field = $el.closest('.field'),
            $label = $field.closest('.field-collapse').find('.field-collapse__heading').children('span'),
            name = $field.find('.field-boxes__heading').first().text();

        if (isChecked) {
            $label.text(name);
        }
    });
};
export const binds = () => {
    // ---------------- input check
    $('body').on('click.checkCollapse', 'input[type=checkbox], input[type=radio]', function(event) {
        toggleChecked($(this));
    });
    toggleChecked($('input[type=checkbox], input[type=radio]'));
};
